<div class="form-container" [formGroup]="UserRequestDetailsformGroup">
  <h4 class="section-title">{{ 'FRONT_USER.USER_INFORMATION' | translate }}</h4>
  <!-- *ngIf='currentUser?.RegisterTypeId == RegisterType.PortalUser||currentUser?.role == role.admin' -->
 <!-- <div  class="form-group">
    <label for="MobileNumber">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.MOBILE' | translate }}</label>
    <span class="red"> *</span>
    <ngx-intl-tel-input [enableAutoCountrySelect]="true" [enablePlaceholder]="true" id="MobileNumber"
      name="MobileNumber" formControlName="MobileNumber"></ngx-intl-tel-input>
    <div *ngIf="SubmitFlag ||(Validate.MobileNumber?.dirty && Validate.MobileNumber?.errors)" class="red">
      <div *ngIf="Validate.MobileNumber?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |translate}}</div>
      <div *ngIf="Validate.MobileNumber?.errors?.validatePhoneNumber" class="red">
        {{'FRONT_USER.REGISTRATION_FORM.VALID_PHONE_NUMBER' | translate}}</div>
    </div>
  </div>-->
  <div *ngIf='currentUser?.RegisterTypeId == RegisterType.Agent || currentUser?.RegisterTypeId == RegisterType.Supplier' class="form-group">
    <label for="MobileNumber">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.MOBILE' | translate }}</label>
    <span class="red"> *</span>
    <input type="text" class="form-control" id="MobileNumber" name="MobileNumber" formControlName="MobileNumber" />
    <div *ngIf="SubmitFlag ||(Validate.MobileNumber?.dirty && Validate.MobileNumber?.errors)" class="red">
      <div *ngIf="Validate.MobileNumber?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |translate}}</div>
      <div *ngIf="Validate.MobileNumber?.errors?.validatePhoneNumber" class="red">
        {{'FRONT_USER.REGISTRATION_FORM.VALID_PHONE_NUMBER' | translate}}</div>
    </div>
  </div>

  <div class="form-group">
    <label for="Fax">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.FAX' | translate }}</label>

    <span *ngIf="!IsFaxOptional" class="red"> *</span>
    <input type="text" class="form-control" id="Fax" name="Fax" formControlName="Fax" />
    <div *ngIf="SubmitFlag ||( Validate.Fax?.errors && Validate.Fax?.dirty)" class="red">
      <div *ngIf="Validate.Fax?.errors?.required">{{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
      <div *ngIf="Validate.Fax?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>

    </div>
    <div *ngIf="Validate.Fax?.errors?.maxlength" class="red">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
  </div>

  <div class="form-group" *ngIf="IsCustomerName">
    <label for="CustomerName">{{ 'FRONT_USER.CUSTOMER_NAME' | translate }}</label>
    <span class="red"> *</span>
    <input type="text" class="form-control" id="CustomerName" name="CustomerName" formControlName="CustomerName" />
    <div *ngIf="SubmitFlag ||(Validate.CustomerName?.errors && Validate.CustomerName?.dirty)" class="red">
      <div *ngIf="Validate.CustomerName?.errors?.required">{{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
      <div *ngIf="Validate.CustomerName?.errors?.pattern">{{ 'FRONT_USER.CHARACTER_ERROR' | translate }}</div>
      <div *ngIf="Validate.CustomerName?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
      </div>
      <div *ngIf="Validate.CustomerName?.errors?.maxlength">{{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
    </div>
  </div>

</div>
